import { createFileRoute } from '@tanstack/react-router';
import CollectionsIndexPage from '@/pages/workspaces/collections/index.page';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { LazyPage } from './-route-layouts';

function CollectionsIndexRoute() {
  return (
    <LazyPage>
      <RumPageRendered>
        <CollectionsIndexPage />
      </RumPageRendered>
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/collections/')({
  component: CollectionsIndexRoute,
});
